/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Scrape_Router_Plan_MonthlyInputs */

const en_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.price}/mo plan`)
};

const zh_hans1_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.price}/月套餐`)
};

const pt_br2_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ plano de ${i?.price}/mês`)
};

const es_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ plan de ${i?.price}/mes`)
};

const fr_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ forfait à ${i?.price}/mois`)
};

const de_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ Tarif für ${i?.price}/Monat`)
};

const ru_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ тариф ${i?.price}/мес.`)
};

const it_scrape_router_plan_monthly = /** @type {(inputs: Scrape_Router_Plan_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ piano da ${i?.price}/mese`)
};

/**
* | output |
* | --- |
* | "+ {price}/mo plan" |
*
* @param {Scrape_Router_Plan_MonthlyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_plan_monthly = /** @type {((inputs: Scrape_Router_Plan_MonthlyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Plan_MonthlyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_plan_monthly(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_plan_monthly(inputs)
	if (locale === "es") return es_scrape_router_plan_monthly(inputs)
	if (locale === "fr") return fr_scrape_router_plan_monthly(inputs)
	if (locale === "de") return de_scrape_router_plan_monthly(inputs)
	if (locale === "ru") return ru_scrape_router_plan_monthly(inputs)
	if (locale === "it") return it_scrape_router_plan_monthly(inputs)
	return en_scrape_router_plan_monthly(inputs)
});